import '@fortawesome/fontawesome-free/css/all.min.css';
import { useEffect, useState } from 'react';
import './Topbar.css';

const Topbar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  // Auto-hide topbar on scroll (optional)
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsVisible(currentScrollY < lastScrollY || currentScrollY < 100);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const socialLinks = [
    {
      icon: 'fa-facebook-f',
      url: 'https://www.facebook.com/bakumia.pk',
      label: 'Facebook',
      color: '#1877F2',
    },
    {
      icon: 'fa-instagram',
      url: 'https://www.instagram.com/bakumia.pk/',
      label: 'Instagram',
      color: '#E4405F',
    },
    {
      icon: 'fa-twitter',
      url: 'https://twitter.com/BakumiaP',
      label: 'Twitter',
      color: '#1DA1F2',
    },
    {
      icon: 'fa-youtube',
      url: 'https://www.youtube.com/channel/UClgC42QRT6uQFLofuy1We4g',
      label: 'YouTube',
      color: '#FF0000',
    },
    {
      icon: 'fa-linkedin',
      url: 'https://www.linkedin.com/company/bakumia/',
      label: 'LinkedIn',
      color: '#0A66C2',
    },
    {
      icon: 'fa-pinterest',
      url: 'https://www.pinterest.com/bakumia22/',
      label: 'Pinterest',
      color: '#BD081C',
    },
    {
      icon: 'fa-tiktok',
      url: 'https://www.tiktok.com/@bakumia.pk',
      label: 'TikTok',
      color: '#000000',
    },
  ];
  const announcements = [
    '📦 Free Shipping When You Spend Rs. 3,000 or More!',
    '↩️ You can return or exchange items after purchase.',
    '🎁 Get 10% Off on Your First Order!',
    'مفت شپنگ جب آپ 3000 روپے یا اس سے زیادہ خرچ کریں 📦',
    'خریداری کے بعد آپ سامان واپس یا تبدیل کر سکتے ہیں۔ ↩️',
    ' اپنی پہلی خریداری پر 10٪ رعایت حاصل کریں🎁 ',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // fade out first
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % announcements.length);
        setFade(true); // fade in
      }, 500); // duration of fade out
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  return (
    <div
      className={`container-fluid topbar d-none d-lg-block ${
        isVisible ? 'topbar--visible' : 'topbar--hidden'
      }`}
    >
      <div className="topbar__container">
        <div className="topbar__content">
          {/* Left Section - Contact & Social */}
          <div className="topbar__left">
            <div className="topbar__contact">
              <a
                href="https://api.whatsapp.com/send?phone=923459403395"
                className="topbar__whatsapp"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contact us on WhatsApp"
              >
                <i className="fab fa-whatsapp" aria-hidden="true"></i>
                <span className="topbar__phone">+92 345 940 3395</span>
              </a>
            </div>

            {/* Social Media Links */}
            <div className="topbar__social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="topbar__social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Follow us on ${social.label}`}
                  style={{ '--hover-color': social.color }}
                >
                  <i className={`fab ${social.icon}`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* Right Section - Announcements */}
          <div className="topbar__right">
            <div className="topbar__announcement">
              <div className="topbar__announcement-content">
                <span
                  className={`topbar__announcement-text ${
                    fade ? 'fade-in' : 'fade-out'
                  }`}
                >
                  {announcements[index]}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
